import React, { useState, useEffect } from "react";
import { columnConfig, pieConf } from "../../component/highchart/chartconfig";
import ChartComponent from "../../component/highchart/ChartComponent";
import Grid from "@material-ui/core/Grid";
import classes from "../../App.module.css";
import { useTranslation } from 'react-i18next';
import "../../assets/css/customstyles.css";
import { apiServices } from '../../services/apiServices';
import OfflineDb from '../../db'
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import swal from 'sweetalert'
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Field } from 'react-final-form';
import DateFnsUtils from '@date-io/date-fns';
//import DatePicker from "react-datepicker";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,useMediaQuery,Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import {
    TextFi,
    DatePicker,
    Checkboxes,
    CheckboxData,
    Radios,
    Select,
    TimePicker,
    Switches,
    KeyboardDatePicker,
    DateTimePicker,
    Autocomplete,
} from "mui-rff";

import '../../assets/css/customstyles.css'
import '../../assets/css/theme_grey.css'
import '../../assets/css/theme_blue.css'
import '../../assets/css/theme_green.css'
import '../../assets/css/theme_red.css'
import _, { values } from 'lodash';
import {
    SingleSelectFieldFF,
    SingleSelectOption,
    MultiSelectField, MultiSelectOption,MultiSelect,
    SingleSelect,
    ReactFinalForm,
    InputFieldFF,
    Field as DHIS2Field
} from '@dhis2/ui';
import { chart } from "highcharts";
const { Form, FormSpy } = ReactFinalForm
const DashboardChart = () => {
    const { t } = useTranslation();
    const styleObject = {
        width: '100%',
        height: '100%',
      };
      const dataObj = {}
      const [years,setYears] = useState([{'value':"2021", 'label': "2021" },{'value':"2022", 'label': "2022" }])
      const [months,setMonths] = useState([{ 'value':"1", 'label':  t("January") },{ 'value':"2", 'label':  t("February") },{ 'value':"3", 'label':  t("March") },{ 'value':"4", 'label':  t("April") },{ 'value':"5", 'label':  t("May") },{ 'value':"6", 'label':  t("June") },{ 'value':"7", 'label':  t("July") },{ 'value':"8", 'label':  t("August") },{ 'value':"9", 'label':  t("September") },{ 'value':"10", 'label':  t("October") },{ 'value':"11", 'label':  t("November") },{ 'value':"12", 'label':  t("December") }])
      const [weeks,setWeeks] = useState([{ 'value':"Week1", 'label': "Week1" },{ 'value':"Week2", 'label': "Week2" },{ 'value':"Week3", 'label': "Week3" },{ 'value':"Week4", 'label': "Week4" },{ 'value':"Week5", 'label': "Week5" }])
      const setGlobalSpinner = useGlobalSpinnerActionsContext()
      const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null)
      const [chartData, setChartData] = React.useState(null)
      const history = useHistory();
      const [orwUsers,setOrwUsers] = useState([])
      const [selectedOptions, setSelectedOptions] = useState([])
      const theme = useTheme();
       const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

      const options = [
        { label: 'Option 1', value: 'option1' },
        { label: 'Option 2', value: 'option2' },
        { label: 'Option 3', value: 'option3' },
    ]
    const data = [
        {
          orwName: 'John Doe',
          reachedTarget: 100,
          testedTarget: 90,
          reached: 95,
          referred: 85,
          tested: 80
        },
        {
          orwName: 'Jane Smith',
          reachedTarget: 110,
          testedTarget: 100,
          reached: 105,
          referred: 95,
          tested: 90
        },
        // Add more data as needed
      ];

    const CustomMultiSelectOption = ({ option, selectedOptions, onCheckboxChange }) => (
        <label className="custom-option" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
            <input
                type="checkbox"
                checked={selectedOptions.includes(option.value)}
                onChange={() => onCheckboxChange(option.value)}
                style={{ marginRight: '8px' }}
            />
            <span>{option.label}</span>
        </label>
    )
    const handleCheckboxChange = (value) => {
        setSelectedOptions(prevSelectedOptions =>
            prevSelectedOptions.includes(value)
                ? prevSelectedOptions.filter(option => option !== value)
                : [...prevSelectedOptions, value]
        )
    }
      async function getMetaData() {
          /*let metadata = await OfflineDb.getDataFromPouchDB('metaData')
          setProgarmData(metadata.data)*/

          let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
          setSessionUserBoValue(loginDetails.data)
      }
      useEffect(() => {
          getMetaData()
          addYear()
      }, [])

      useEffect(() => {
        setMonths([{ 'value':"1", 'label': t("January") },{ 'value':"2", 'label': t("February") },{ 'value':"3", 'label':  t("March") },{ 'value':"4", 'label':  t("April") },{ 'value':"5", 'label':  t("May") },{ 'value':"6", 'label':  t("June") },{ 'value':"7", 'label':  t("July") },{ 'value':"8", 'label':  t("August") },{ 'value':"9", 'label':  t("September") },{ 'value':"10", 'label':  t("October") },{ 'value':"11", 'label':  t("November") },{ 'value':"12", 'label':  t("December") }])
    }, [localStorage.getItem('locale')])
    
    function addYear() {
        let currentYear = moment().year()
        if(currentYear != "2021" && currentYear != "2022"){
            currentYear = currentYear.toString()
            years.push({'value':currentYear, 'label': currentYear })
            setYears(years)
        }
        //console.log("years",currentYear,years);
    }
    useEffect(() => {
        //setYears = [{'value':2020, 'label': "2020" },{'value':2021, 'label': "2021" },{'value':2022, 'label': "2022" }] 
        //setMonths = [{ 'value':1, 'label': "January" },{ 'value':2, 'label': "February" },{ 'value':3, 'label': "March" },{ 'value':4, 'label': "April" },{ 'value':5, 'label': "May" },{ 'value':6, 'label': "February" },{ 'value':7, 'label': "July" },{ 'value':8, 'label': "August" },{ 'value':9, 'label': "September" },{ 'value':10, 'label': "October" },{ 'value':11, 'label': "November" },{ 'value':12, 'label': "December" }]
        //https://eosavemyn.imonitorplus.com/service/api/userGroups?filter=name:eq:SupervisorUser&fields=id,displayName,users[id,name] - use this api for getting the ORWs associated with Supervisor login
        if(sessionUserBoValue != null){
            let supervisorName = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.userCredentials ? sessionUserBoValue.username : null : null : null;
            console.log('sessionUserBoValue',sessionUserBoValue,sessionUserBoValue.userCredentials)
            const getURL = 'userGroups?filter=name:eq:'+supervisorName+'&fields=id,displayName,users[id,name]'
            setGlobalSpinner(true)
            apiServices.getAPI(getURL)
                .then(res => {
                    console.log("res",res);
                    if(res && res.data && res.data.userGroups && res.data.userGroups.length > 0){
                        let orwusers = []
                        res.data.userGroups[0].users.map(user => {
                            var obj = { 'value': user.id, 'label': user.name }
                            orwusers.push(obj)
                        })
                        setOrwUsers(orwusers)
                    }
                    setGlobalSpinner(false)
                }).catch(err => {
                    swal({
                        title: t("Error"),
                        text: t("Sorry, something went wrong"),
                        icon: "error",
                        buttons: t('Close')
                    })
                    setGlobalSpinner(false)
                })
            }else if(!navigator.onLine){
                swal({
                    title: "Error",
                    text: t("Data could not be shown in offline mode."),
                    icon: "error",
                    button: "Close",
                }).then(alertRes => {
                    history.push('/layout/home')
                });
            }
    },[sessionUserBoValue])
    
    const GetDataForChart = (data) => { 
        console.log("data",data); 
      return columnConfig('column', data, [], t('Target'),[t('Reached count'),t('Target count'),t('Contact count')], t);
    };
    const haldleSubmitAction = (values) => {
        console.log();
    }
    function getMonthwiseReport(data){
        let param = {}
        let supervisorOrgUnit = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.organisationUnits && sessionUserBoValue.organisationUnits.length > 0 ? sessionUserBoValue.organisationUnits[0].id : null : null : null;
        //  let selectedYear = data ? data.years : '';//data["years"];
        //  let selectedMonth = data ? data.month : '';//data["month"];
        let start = data ? data.Datefrom : "";
        let end = data ? data.DateTo : ""; 
        let orwid = data ? data.orw : '';//data["month"];
        if(!start || !end){
            swal({
                title: t("Alert"),
                text: t("Please select date"),
                icon: "warning",
                buttons: t('Close')
            })
            return;
        }
        //console.log("startDate",startDate,endDate)

        // let startDate = new Date(start)
        // let year = startDate.getFullYear().toString(); // Get last two digits of the year
        // let month = ('0' + (startDate.getMonth() + 1)).slice(-2); // Months are zero-based, so add 1 and pad with zero if needed
        // let day = ('0' + startDate.getDate()).slice(-2); // Pad day with zero if needed

        let formattedstartdate =  moment(start).format('YYYY-MM-DD')//`${year}-${month}-${day}`;
        console.log("formattedstartdate",formattedstartdate)

        // let endDate = new Date(end)
        // let endyear = endDate.getFullYear().toString(); // Get last two digits of the year
        // let endmonth = ('0' + (endDate.getMonth() + 1)).slice(-2); // Months are zero-based, so add 1 and pad with zero if needed
        // let endday = ('0' + endDate.getDate()).slice(-2); // Pad day with zero if needed

        let formattedenddate = moment(end).format('YYYY-MM-DD')//`${endyear}-${endmonth}-${endday}`;

        if (formattedstartdate > formattedenddate){
            swal({
                title: t("Error"),
                text: t("Date from should be greater than Date to"),
                icon: "error",
                buttons: t('Close')
            })
            return
        }


        if(sessionUserBoValue &&  sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles.length > 0 && sessionUserBoValue.userRoles[0]["name"] == 'ORW'){
            orwid = sessionUserBoValue.id
        }else{
            orwid = selectedOptions ? selectedOptions.join(';') : '';
        }
        console.log("data",data,supervisorOrgUnit,selectedOptions,orwid)
        param = {"orwid":orwid,
                // "year":selectedYear,
                // "month":selectedMonth,
                "startDate":formattedstartdate,
                "endDate":formattedenddate}
        console.log("param",param)
        let postUrl = 'save/dashboard/gettargetclassifiation';
        setGlobalSpinner(true)
        apiServices.postAPI(postUrl, param)
        .then(res => {
              setGlobalSpinner(false)
              console.log("res",res);
              let ChartDataArray = []
              res.data.data.map((el,i) =>{
                //el.count = i+10
                if(sessionUserBoValue &&  sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles.length > 0 && sessionUserBoValue.userRoles[0]["name"] == 'ORW'){

                    if(el.orwusername){
                        for(let indicator in el.indicators){
                            if(indicator != "reffered")
                                ChartDataArray.push({
                                    "name": indicator,
                                    "translation":t(indicator),
                                    "value": [el.indicators[indicator]]
                                })
                        } 
                    } 
                }else{
                    if(el.orwusername)
                        ChartDataArray.push({
                            orwName: _.find(orwUsers,{value : el.orwusername}) ? _.find(orwUsers,{value : el.orwusername})["label"] : el.orwusername,
                            contactTarget: el.indicators["contact_target"] ? el.indicators["contact_target"] : t('N/A'),
                            contact: el.indicators["Contact"] ? el.indicators["Contact"] : t('N/A'),
                            reachedTarget: el.indicators["reached_target"] ? el.indicators["reached_target"] : t('N/A'),
                            testedTarget: el.indicators["tested_target"] ? el.indicators["tested_target"] : t('N/A'),
                            reached: el.indicators["reached"] ? el.indicators["reached"] : t('N/A'),
                            referred: el.indicators["reffered"],
                            tested: el.indicators["tested"] ? el.indicators["tested"] : t('N/A')
                        })
                }
                    //     if ([el.count]== 0){
                    //     swal({
                    //         title: t("Error"),
                    //         text: t("Date from should be greater than Date to"),
                    //         icon: "error",
                    //         buttons: t('Close')
                    //     })
                    // }
              })
              console.log("ChartDataArray",ChartDataArray)
              setChartData(ChartDataArray)
          }).catch(err => {
            swal({
                title: t("Error"),
                text: t("Sorry, something went wrong"),
                icon: "error",
                buttons: t('Close')
            })
            setGlobalSpinner(false)
            history.push('/layout/home')
        })
    }
    const renderChart = (chartData) => {
      return(
        <ChartComponent
            options={GetDataForChart(chartData)}
            styleObj={styleObject}
            //style={{ overflow: "scroll" }}
        />
      )
    }
    const required = values => values ? undefined : 'Required'

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error )
    console.log("composeValidators",composeValidators, required)

    const getTargetValue = (keyword) => {
        return (
          chartData.find((item) => item.name.includes(keyword) && item.name.includes("target"))?.value[0] || ""
        );
      };
    
      const getAchievementValue = (keyword) => {
        return (
          chartData.find((item) => item.name.toLowerCase().includes(keyword) && !item.name.includes("target"))?.value[0] || ""
        );
      };


    return (
        <div className={classes.container}>
        <main style={{ display: 'flex', height: '100%', width: '100%', }}>
            <section
                style={{
                    flexGrow: 1,
                    padding: 0,
                }}
            >
            {sessionUserBoValue !=null ?
            <Grid container spacing={3} className="mt-60px mb-30px registration-page alerts_page">
            <Form
                onSubmit={(values) => haldleSubmitAction(values)}
                render={({ handleSubmit, form, submitting, pristine, values }) => (
                  <form id="target-search" onSubmit={handleSubmit} style={{width: '100%'}}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={4} lg={4} className={sessionUserBoValue &&  sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles.length > 0 && sessionUserBoValue.userRoles[0]["name"] == 'ORW' ? 'hide' : ''}>
                            <Field name="orw">
                        {({ input, meta }) => (
                            <DHIS2Field label={t('Select ORW')}>
                                <MultiSelect
                                    selected={selectedOptions}
                                    //onChange={({ selected }) => input.onChange(selected)}
                                    onChange={({ selected }) => {
                                        input.onChange(selected)
                                        setSelectedOptions(selected)
                                    }}
                                >
                                    {orwUsers.map(option => (
                                        <MultiSelectOption
                                            key={option.value}
                                            value={option.value}
                                            label={
                                                <CustomMultiSelectOption
                                                    option={option}
                                                    selectedOptions={selectedOptions}
                                                    onCheckboxChange={handleCheckboxChange}
                                                />
                                            }
                                        />
                                    ))}
                                </MultiSelect>
                                {meta.touched && meta.error && (
                                    <span className="error">{meta.error}</span>
                                )}
                            </DHIS2Field>
                        )}
                    </Field>
                                {/* <Field
                                    id="orw"
                                    name="orw"
                                    label={t('Select ORW')}
                                    component={SingleSelectFieldFF}
                                    //key="orw"
                                    options={orwUsers != null ? orwUsers : []}
                                /> */}
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                {/* <Field
                                    id="years"
                                    name="years"
                                    label={t('Select Year')}
                                    required={true}
                                    component={SingleSelectFieldFF}
                                    key="years"
                                    //validate={composeValidators(required(values))}
                                    options={years != null ? years : []}
                                /> */}
                                <DatePicker
                                  disabled={false}
                                  label={t("Date from")}
                                  name={"Datefrom"}
                                  required={true}
                                  //value={""}
                                  dateFunsUtils={DateFnsUtils}
                                  margin="normal"
                                  variant="inline"
                                  format={"yyyy-MM-dd"}
                                  //validate={composeValidators(required(values))}
                                //   disableFuture={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                {/* <Field
                                    id="month"
                                    name="month"
                                    label={t('Select Month')}
                                    component={SingleSelectFieldFF}
                                    key="month"
                                    options={months != null ? months : []}
                                /> */}
                                <DatePicker
                                  disabled={false}
                                  label={t("Date To")}
                                  name={"DateTo"}
                                  required={true}
                                  dateFunsUtils={DateFnsUtils}
                                  margin="normal"
                                  variant="inline"
                                  format={"yyyy-MM-dd"}
                                  validate={true}
                                //   disableFuture={true}
                                  />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} className='hide'>
                                <Field
                                    id="week"
                                    name="week"
                                    label={t('Select week')}
                                    component={SingleSelectFieldFF}
                                    key="week"
                                    options={weeks != null ? weeks : []}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: '10px' }}>
                            <button style={{ float: 'right' }} className="regformsubmitbtn" type="button" onClick={() => getMonthwiseReport(values)}>
                                {t('Apply')}
                            </button>
                        </Grid>
                  </form>
                )}
              />
              {sessionUserBoValue &&  sessionUserBoValue.userCredentials && sessionUserBoValue.userRoles && sessionUserBoValue.userRoles.length > 0 && sessionUserBoValue.userRoles[0]["name"] == 'ORW' ? 
                <Grid container spacing={0} xs={12} lg={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: '15px' }}>
                        {console.log("chartData",chartData)}
                        {chartData != null ? 
                            // renderChart(chartData)
                            <TableContainer component={Paper}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell></TableCell>
                                  <TableCell align="center">{t("Target")}</TableCell>
                                  <TableCell align="center">{t("Achievement")}</TableCell>

                                  {/* <TableCell align="center">"Target" :{t("Specified number")}</TableCell>
                                  <TableCell align="center">Achievement :{t("Number of services rendered")}</TableCell> */}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {/* Hardcoded rows */}
                                <TableRow>
                                  <TableCell>
                                  Contact :{t("Number of times HIV prevention services were provided (during this year)")}
                                  </TableCell>
                                  <TableCell align="center">{getTargetValue("contact")? getTargetValue("contact") : "N/A"}</TableCell>
                                  <TableCell align="center">{getAchievementValue("contact") ? getAchievementValue("contact") : "N/A" }</TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>
                                  Reached :{t("Number of new clients provided HIV prevention services (during this year)")}
                                  </TableCell>
                                  <TableCell align="center">{getTargetValue("reached")? getTargetValue("reached") : "N/A"}</TableCell>
                                  <TableCell align="center">{getAchievementValue("reached") ? getAchievementValue("reached") : "N/A" }</TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>Tested :{t("HIV test")}</TableCell>
                                  <TableCell align="center">{getTargetValue("tested")? getTargetValue("tested") : "N/A"}</TableCell>
                                  <TableCell align="center">{getAchievementValue("tested") ? getAchievementValue("tested") : "N/A" }</TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        :<></>}
                    </Grid>
                </Grid>
              : 
                    selectedOptions && selectedOptions.length > 0 && chartData != null &&
                    <Grid container spacing={0} xs={12} lg={12}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                        <br/>
                        <TableContainer component={Paper}>
                        {!isMobile ? (
                            <Table>
                            <TableHead>
                                <TableRow>
                                <TableCell>{t("ORW Name")}</TableCell>
                                <TableCell>{t("Contact target")}</TableCell>
                                <TableCell>{t("Contact")}</TableCell>
                                <TableCell>{t("reached_target")}</TableCell>
                                <TableCell>{t("reached")}</TableCell>
                                <TableCell>{t("tested_target")}</TableCell>
                                {/* <TableCell>{t("Referred")}</TableCell> */}
                                <TableCell>{t("tested")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {chartData.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.orwName}</TableCell>
                                    <TableCell>{row.contactTarget}</TableCell>
                                    <TableCell>{row.contact}</TableCell>
                                    <TableCell>{row.reachedTarget}</TableCell>
                                    <TableCell>{row.reached}</TableCell>
                                    <TableCell>{row.testedTarget}</TableCell>
                                    {/* <TableCell>{row.referred}</TableCell> */}
                                    <TableCell>{row.tested}</TableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                            </Table>
                        ) : (<Grid container spacing={0} xs={12} lg={12}>
                                {chartData.map((row, index) => (
                                    <Grid item xs={12} sm={12} md={12} lg={12} className="app-table">
                                        <Table>
                                            <TableBody>
                                                <React.Fragment key={index}>
                                                    <TableRow>
                                                    <TableCell colSpan={2}>
                                                        <Typography variant="h6">{row.orwName}</Typography>
                                                    </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                    <TableCell>{t("Contact Target")}</TableCell>
                                                    <TableCell>{row.contactTarget}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                    <TableCell>{t("Contact")}</TableCell>
                                                    <TableCell>{row.contact}</TableCell>
                                                    </TableRow>                                                    
                                                    <TableRow>
                                                    <TableCell>{t("Reached Target")}</TableCell>
                                                    <TableCell>{row.reachedTarget}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                    <TableCell>{t("Reached")}</TableCell>
                                                    <TableCell>{row.reached}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                    <TableCell>{t("Tested Target")}</TableCell>
                                                    <TableCell>{row.testedTarget}</TableCell>
                                                    </TableRow>
                                                    
                                                    {/* <TableRow>
                                                    <TableCell>{t("Referred")}</TableCell>
                                                    <TableCell>{row.referred}</TableCell>
                                                    </TableRow> */}
                                                    <TableRow>
                                                    <TableCell>{t("Tested")}</TableCell>
                                                    <TableCell>{row.tested}</TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            </TableBody>
                                        </Table>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                        </TableContainer>
                        </Grid>
                    </Grid>
              }   
            </Grid>
            : <></>
            }
            </section>
            </main>
        </div>
    )
}

export default DashboardChart;